import PropTypes from "prop-types"
import React, { useEffect, useLayoutEffect } from "react"
import SimpleBar from "simplebar-react"
import { useTranslation } from "react-i18next"
import withRouter from "components/Common/withRouter"
import { applyDocumentLanguage } from "utils/i18nDocument"
import {
  changeLayoutMode,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  showRightSidebarAction,
} from "../../store/actions"

// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import BottomNavigation from "./BottomNavigation"
import RightSidebar from "../CommonForBoth/RightSidebar"
import SuperAdminThemeBridge from "components/SuperAdmin/SuperAdminThemeBridge"
import TenantThemeBridge from "components/Tenant/TenantThemeBridge"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

const Layout = props => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const isRtl = i18n.language === "sa"

  // The scroll container below depends on the language, and the RTL document
  // rules lock page scrolling. They must always change together.
  useLayoutEffect(() => {
    applyDocumentLanguage(i18n.language)
  }, [i18n.language])

  const selectLayoutProperties = createSelector(
    state => state.Layout,
    layout => ({
      isPreloader: layout.isPreloader,
      layoutModeType: layout.layoutModeType,
      leftSideBarThemeImage: layout.leftSideBarThemeImage,
      leftSideBarType: layout.leftSideBarType,
      layoutWidth: layout.layoutWidth,
      topbarTheme: layout.topbarTheme,
      showRightSidebar: layout.showRightSidebar,
      leftSideBarTheme: layout.leftSideBarTheme,
    })
  )

  const {
    isPreloader,
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    showRightSidebar,
    leftSideBarTheme,
    layoutModeType,
  } = useSelector(selectLayoutProperties)

  const accountType = useSelector(state => state.Login?.accountType)
  const accountScope = useSelector(state => state.Login?.accountScope)
  const isSuperAdminSession =
    accountScope === "super_admin" || accountType === "superadmin"

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile))
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile))
    }
  }

  //hides right sidebar on body click
  const hideRightbar = event => {
    var rightbar = document.getElementById("right-bar")
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false))
    }
  }

  /*
  layout  settings
  */

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true)
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
    const main = document.getElementById("main-content-rtl")
    if (main) {
      main.scrollTop = 0
    }
  }, [])

  useEffect(() => {
    document.getElementById("main-content-rtl").classList.add("rtl-content")
    document.getElementById("page-topbar").classList.add("rtl-page-topbar")
    document.getElementById("main-content-rtl").classList.remove("rtl-content-hor")
    document.getElementById("page-topbar").classList.remove("rtl-page-topbar-hor")
  }, [])

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme))
    }
  }, [leftSideBarTheme, dispatch])

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType))
    }
  }, [layoutModeType, dispatch])

  useEffect(() => {
    if (leftSideBarThemeImage) {
      dispatch(changeSidebarThemeImage(leftSideBarThemeImage))
    }
  }, [leftSideBarThemeImage, dispatch])

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth))
    }
  }, [layoutWidth, dispatch])

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType))
    }
  }, [leftSideBarType, dispatch])

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme))
    }
  }, [topbarTheme, dispatch])

  return (
    <React.Fragment>
      <div
        id="layout-wrapper"
        className={isSuperAdminSession ? "layout-platform" : undefined}
      >
        {isSuperAdminSession ? <SuperAdminThemeBridge /> : null}
        {!isSuperAdminSession ? <TenantThemeBridge /> : null}
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />
        <div className="main-content" id="main-content-rtl">
          {isRtl ? (
            <SimpleBar
              className="main-content-scroll h-100"
              autoHide={false}
              forceVisible="y"
            >
              {props.children}
            </SimpleBar>
          ) : (
            props.children
          )}
        </div>
        <Footer />
        {!isSuperAdminSession ? <BottomNavigation /> : null}
      </div>
      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  )
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
}

export default withRouter(Layout)
